import HomeView from "@/views/HomeView.vue";
import AppBuyer from "@/AppBuyer";

const routes = [
    {
        path: "",
        redirect: "/home",
        component: AppBuyer,
        children: [
            {
                path: "home",
                component: HomeView
            },
            {
                name: "Login",
                path: "login",
                component: () => import("@/views/LoginView.vue")
            },
            {
                path: "register",
                component: () => import("@/views/RegisterView.vue")
            },
            {
                path: "shops/create",
                component: () => import("@/views/ShopCreate.vue")
            },
            {
                path: '/tron_qrcode',
                component: () => import('@/views/scan/tron_qrcode')
            },
            {
                path: "shops/support",
                component: () => import("@/views/shopSupport.vue")
            },
            {
                path: "categories",
                component: () => import("@/views/CategoriesView.vue")
            },
            {
                path: "category",
                component: () => import("@/views/ProductsListView.vue")
            },
            {
                path: "product",
                component: () => import("@/views/ProductView.vue")
            },
            {
                path: "brands",
                component: () => import("@/views/BrandsView.vue")
            },
            {
                path: "brand",
                component: () => import("@/views/ProductsListView.vue")
            },
            {
                path: "search",
                component: () => import("@/views/ProductsListView.vue")
            },
            {
                path: "shop",
                component: () => import("@/views/ShopView.vue")
            },
            {
                path: "sellers",
                component: () => import("@/views/SellersView.vue")
            },
            {
                path: "password/reset",
                component: () => import("@/views/PasswordResetView.vue")
            },
            {
                path: "terms",
                component: () => import("@/views/TermsView.vue")
            },
            {
                path: "blog",
                component: () => import("@/views/BlogsView.vue")
            },
            {
                path: "single-blog",
                component: () => import("@/views/BlogView.vue")
            },
            {
                path: "flash-deals",
                component: () => import("@/views/FlashDealsView.vue")
            },
            {
                path: "loginToUser",
                component: () => import("@/views/loginToUser.vue")
            },
            {
                path: "buyback",
                component: () => import("@/views/Buyback.vue")
            },
            {
                path: "seckill",
                component: () => import("@/views/SeckillView.vue")
            },
        ]
    },
    {
        path: "/user",
        redirect: "/user/index",
        component: AppBuyer,
        children: [
            {
                path: "taskOrder",
                component: () => import("@/views/user/taskOrder.vue")
            },
            {
                path: "taskOrderDetail",
                component: () => import("@/views/user/taskOrderDetail.vue")
            },
            {
                path: "assist",
                component: () => import("@/views/user/assist.vue")
            },
            {
                path: "cart",
                component: () => import("@/views/user/cart.vue")
            },
            {
                path: "checkout",
                component: () => import("@/views/user/checkout.vue")
            },
            {
                path: "checkout/delivery_info",
                component: () => import("@/views/user/checkoutDeliveryInfo.vue")
            },
            {
                path: "checkout/payment_select",
                component: () => import("@/views/user/checkoutPayment.vue")
            },
            {
                path: "dashboard",
                component: () => import("@/views/user/index.vue")
            },
            {
                path: "purchase_history",
                component: () => import("@/views/user/orderList.vue")
            },
            {
                path: "order_detail",
                component: () => import("@/views/user/orderDetail.vue")
            },
            {
                path: "digital_purchase_history",
                component: () => import("@/views/download.vue")
            },
            {
                path: "wishlists",
                component: () => import("@/views/WishlistView.vue")
            },
            {
                path: "compare",
                component: () => import("@/views/user/compare.vue")
            },
            {
                path: "wallet",
                component: () => import("@/views/user/wallet.vue")
            },
            {
                path: "transaction",
                component: () => import("@/views/user/transactionPassword.vue")
            },
            {
                path: "brands",
                component: () => import("@/views/BrandsView.vue")
            },
            {
                path: "profile",
                component: () => import("@/views/user/profile.vue")
            },
            {
                path: "conversations",
                component: () => import("@/views/user/conversations.vue")
            },
            {
                path: "conversation_detail",
                component: () => import("@/views/user/conversationDetail.vue")
            },
            {
                path: "all-notifications",
                component: () => import("@/views/user/NotificationsView.vue")
            },
        ]
    },
    {
        path: "/user/paySuccess",
        component: () => import("@/views/user/paySuccess.vue")
    }
];
export default routes;
